import * as types from './action-types';

export const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SUPPLIER_LEDGER_TYPES:
      return action.payload.slice(0);
    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/supplier-ledger-types/reducer.js
 **/